import { useSelector } from 'react-redux';
import { InlineLink, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectChangePlan } from '@app/redux/changePlan';

import TermsAndConditionsModal from './TermsAndConditionsModal';
import { ModalTypes } from '../../../../types';

import styles from './styles.module.scss';

type TermsAndConditionsProps = {
  openModal: (e: React.MouseEvent<HTMLElement>, modalType: ModalTypes) => void;
  closeModal: () => void;
  isModalOpen: boolean;
};

const TermsAndConditions = ({ openModal, closeModal, isModalOpen }: TermsAndConditionsProps) => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.details.terms',
  });

  const { requiresEquipmentChange } = useSelector(selectChangePlan);

  const noticeText = requiresEquipmentChange ? t('phase2Notice') : t('notice');

  return (
    <div data-cy="terms-notice" className={styles['terms-notice']}>
      <Txt variant="smallRegular" component="span">
        {noticeText}
      </Txt>
      <InlineLink href="#" onClick={(e) => openModal && openModal(e, 'terms&conditions')}>
        <Txt variant="smallRegular" component="span">
          {t('buttonLink')}
        </Txt>
      </InlineLink>
      <TermsAndConditionsModal isOpen={isModalOpen} handleClose={closeModal} />
    </div>
  );
};

export default TermsAndConditions;
